import axios from 'axios';
import resolve  from '../resolver.js';
import checkJwt from '../../Global/jwtChecker' 
import logout from '../../Global/logout' 
import moment from 'moment'


export default async function GetAmount(
    fromDate,
    toDate
) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    let queryData = "?fromDate=" + moment(new Date(fromDate)).format("YYYY-MM-DD") + 
    "&toDate=" + moment(new Date(toDate)).format("YYYY-MM-DD")

    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/getAmount' + queryData , {
            method: 'GET',
            headers: { 'Authorization' : unHashedJwt},
            data:{
                fromDate,
                toDate
            }     
        }).then(
            res => (res)
        ).catch(error => error.response.data)
    )
}